function redirectToLogin() {
  window.location.href = '/login'
}

export { redirectToLogin }
